export function formatThousands(value: number | null) {
  return value != null ? `${Math.round(value / 1000).toLocaleString('de-DE')}K` : value;
}

export function formatCurrency(value: number | null, symbol: string = '', left?: boolean) {
  if (value === null) return value;

  const number = Math.round(value).toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return left ? `${symbol}${number}` : `${number}${symbol}`;
}

export function formatSlicedText(text: string | null, max: number) {
  return text != undefined && text?.length >= max ? `${text?.slice(0, max)}...` : text;
}

export function formatString(fmt: string, ...args: any[]): string {
  const re = /(%?)(%([ojds]))/g;

  if (args.length) {
    fmt = fmt.replace(re, (match, escaped, ptn, flag) => {
      let arg = args.shift();

      switch (flag) {
        case 'o':
          if (Array.isArray(arg)) {
            arg = JSON.stringify(arg);
          }
          break;
        case 's':
          arg = '' + arg;
          break;
        case 'd':
          arg = Number(arg);
          break;
        case 'j':
          arg = JSON.stringify(arg);
          break;
        default:
          break;
      }

      if (!escaped) {
        return arg;
      }

      args.unshift(arg);
      return match;
    });
  }

  // arguments remain after formatting
  if (args.length) {
    fmt += ' ' + args.join(' ');
  }

  // update escaped %% values
  fmt = fmt.replace(/%{2,2}/g, '%');

  return '' + fmt;
}
